export enum StorageKeys {
  AUTH_TOKEN_STORAGE_KEY = '@slp-ap2-authToken',
  ACTIVE_USER_STORAGE_KEY = '@slp-ap2-activeUser',
  AUTH_VERSION_STORAGE_KEY = '@slp-ap2-authVersion',
}
